<template>
  <g>
    <circle
      v-for="(c, i) in nodes"
      :key="i"
      class="node"
      :style="getNodeStyle"
      :data-index="i"
      v-bind="circleProps(c.pos)"
      :class="{ selected: c.selected }"
      ref="nodeRef"
      @mousedown="onClickNode($event, i)"
    />
  </g>
</template>

<script>
import useConnect from "@/composables/useConnect";
import useEdges from "@/composables/useEdges";
import useBasicStyles from "@/composables/useBasicStyles";
import { computed, toRefs, inject } from "@vue/composition-api";
import ui from "@/store/modules/ui";

export default {
  props: {
    NodesSymbol: Symbol,
    edgeRef: Array,
    setBlock: Function,
    shouldBlock: Boolean
  },
  setup(props) {
    //
    // Props
    // -------------------------------------------------------------------
    //
    const { edgeRef, shouldBlock } = toRefs(props);
    const { setBlock, NodesSymbol } = props;
    //
    // Composables
    // ---------------------------------------------------------------
    //
    const nodesComposable = inject(NodesSymbol);
    const {
      nodeRef,
      nodes,
      move: moveNode,
      remove: removeNode,
      detectVHNeighbors
    } = nodesComposable;
    const { connect, snapTool: snap } = useConnect(nodeRef, edgeRef);
    const { addDoorFromNodeTool: addDoorFromNode } = useEdges(edgeRef, nodeRef);
    const { circleStyles } = useBasicStyles();
    //
    // Events: Click on Node
    // -------------------------------------------------------------------
    //
    function onClickNode(e, i) {
      if (shouldBlock.value) return;
      notifyChange();

      switch (ui.annoType) {
        case "move":
          moveNode(e, i);
          break;
        case "connect":
          setBlock(true);
          connect(e, i)
            .catch(e => {
              console.error("Error at connect in Annotator: " + e);
            })
            .finally(() => {
              setBlock(false);
            });
          break;
        case "snap":
          setBlock(true);
          snap(e, i)
            .catch(e => {
              console.error("Error at snap in Annotator: " + e);
            })
            .finally(() => {
              setBlock(false);
            });
          break;
        case "detect":
          detectVHNeighbors(e, i);
          break;
        case "addDoor":
          setBlock(true);
          addDoorFromNode(e, "door")
            .catch(error => {
              console.error("Error at addDoorFromNode in Annotator: ");
              console.error(error);
            })
            .finally(() => {
              setBlock(false);
            });
          break;
        case "addWindow":
          setBlock(true);
          addDoorFromNode(e, "window")
            .catch(error => {
              console.error("Error at addDoorFromNode in Annotator: ");
              console.error(error);
            })
            .finally(() => {
              setBlock(false);
            });
          break;
        case "remove":
          removeNode(e, i);
          break;
      }
    }
    function notifyChange() {
      if (!ui.hasUnsavedChange) {
        ui.setHasUnsavedChange(true);
      }
    }
    //
    // Styles
    // -------------------------------------------------------------------
    //
    const getNodeStyle = computed(() => {
      return {
        ...circleStyles.value,
        opacity: ui.annotationAlpha
      };
    });
    function circleProps(pos) {
      return { ...pos, r: ui.circleRadius };
    }

    return {
      nodeRef,
      nodes,
      getNodeStyle,
      circleProps,
      onClickNode
    };
  }
};
</script>

<style lang="scss" scoped>
.node {
  fill: var(--fill);
}
.node:hover {
  stroke: greenyellow;
  stroke-width: var(--stroke-width-hover);
}
.node.selected {
  fill: red;
}
</style>
